import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { removeSpecialCharacters } from "../utils";

const Breadcrumb = (props) => {
  const { push, guideline, topic, pathname, mpstopicfile } = props;
  const [tocID, setTocID] = useState("");

  useEffect(() => {
    if (mpstopicfile && guideline) {
      const guidelineClean = removeSpecialCharacters(guideline).replace(
        / /g,
        "_"
      );
      let toc = mpstopicfile[guidelineClean].text;

      if (toc && toc.includes("_")) {
        toc = toc.replace(/_+/g, " ").trim().replace(/\s+/g, " ");
      }

      setTocID(toc);
    }
  }, [mpstopicfile, guideline]);

  const openLink = () => {
    const url = `/viewTopic/?guidelinePage=${encodeURIComponent(
      guideline
    )}&etgAccess=true`;
    push(url);
  };

  return (
    <ul className="breadcrumb">
      <li>
        <a href="/etgAccess">Therapeutic Guidelines</a>
        {guideline && (
          <>
            {" "}
            &gt;&nbsp;
            <a href="#" onClick={() => openLink()}>
              {tocID}
            </a>
          </>
        )}
        {topic && <> &gt;&nbsp; {topic}</>}
        {pathname.includes("searchAction") && <> &gt;&nbsp; Search Results</>}
        {pathname.includes("calculator") && <> &gt;&nbsp; Calculators</>}
        {pathname.includes("patientInfo") && (
          <> &gt;&nbsp; Patient information and useful PDFs</>
        )}
        {pathname.includes("quicklinks") && (
          <> &gt;&nbsp; Drug use in pregnancy and breastfeeding</>
        )}
        {pathname.includes("myCart") && <> &gt;&nbsp; My Cart</>}
        {pathname.includes("userConfirmation") && (
          <> &gt;&nbsp; User Confirmation</>
        )}
        {pathname.includes("checkout") && <> &gt;&nbsp; Checkout</>}
        {pathname.includes("showMyProfile") && <> &gt;&nbsp; My Account</>}
      </li>
    </ul>
  );
};

Breadcrumb.propTypes = {
  push: PropTypes.func.isRequired,
  guideline: PropTypes.string,
  topic: PropTypes.string,
  mpstopicfile: PropTypes.object,
  pathname: PropTypes.string.isRequired,
};

export default Breadcrumb;
